<nav class="head-nav">
    <div class="nav-container">
        <div>
            <h2>{{ "restaurant.Menu Items Categories" | translate }}</h2>
            <ol class="breadcrumb">
                <li class="breadcrumb-item">
                    <a [routerLink]='["/admin"]'>{{ "general.Home" | translate }}</a>
                </li>
                <li class="breadcrumb-item" *ngIf="restaurantId">
                    <a class="breadcrumb-restaurant-name" [routerLink]='["/admin/restaurants/profile", restaurantId]'>{{restaurantData?.name}}</a>
                </li>
                <li class="breadcrumb-item" *ngIf="!isProfile">
                    {{"menu.Menus Management" | translate}}
                </li>
                <li class="breadcrumb-item">{{ "restaurant.Menu Items Categories" | translate }}</li>
            </ol>
        </div>
        <app-restaurants-dropdown (all)="restaurantId = $event; GetScreenData();"></app-restaurants-dropdown>
    </div>
</nav>

<div class="page">
    <div class="page-filters" [hidden]="dataLoading">
        <div class="sort-item">
            <span class="count-page">
                <span>{{recordsData?.totalCount}}</span> {{ "content3.Categories" | translate }}
            </span>

            <label>{{ 'general.Sorted by' | translate }}:</label>
            <select class="form-control" (change)="getAll(null, restaurantId)" [(ngModel)]="filterModel.sortItems">
                <option *ngFor="let sortItem of sortItems" [value]="sortItem.value">{{sortItem.name}}</option>
            </select>
        </div>

        <div class="filters-container" *ngIf='!dataLoading'>
            <div class="search-input">
                <mat-form-field appearance="legacy" *ngIf="showSearch">
                    <input matInput autocomplete="off" [(ngModel)]="filterModel.searchText"
                        (keydown.enter)="makeSearch()" maxlength="20">
                    <mat-icon (click)="resetSearch(); showSearch = false;" matSuffix>clear</mat-icon>
                </mat-form-field>
                <button mat-icon-button (click)="makeSearch()">
                    <img src="./assets/images/icons/search.svg">
                </button>
            </div>

            <button (click)="showFilter = !showFilter" [ngClass]='{"active": showFilter}' class="btn dropdown-custom">
                <img src="./assets/images/icons/filter-outline.svg">
                <span>{{"general.Filter" | translate}}</span>
                <svg width="8" height="5.001" viewBox="0 0 8 5.001">
                    <path id="menu-icon" d="M-3.562-9.316-.5-6.215l3.062-3.1.938.949-4,4.051-4-4.051Z"
                        transform="translate(4.5 9.316)" fill="#6a6a6a" opacity="0.8" />
                </svg>
            </button>
            <div class="create-item">
                <a class="btn-light" *ngIf="recordsData?.canAdd" mat-stroked-button (click)="openForm()">
                    <img src="./assets/images/icons/plus-ic.svg">
                    <span>{{"content3.Add New Category" | translate}}</span>
                </a>
            </div>
        </div>

        <div class="filter-section" [hidden]="!showFilter">
            <h4 class="title">{{"general.Filter by" | translate}}</h4>
            <div [formGroup]="filterFormGroup" class="row">
                <div class="col-lg-4 mb-3">
                    <mat-form-field class="no-validation">
                        <mat-label>{{"forms.Creation Date From" | translate}}</mat-label>
                        <input matInput [matDatepicker]="createdFrom" formControlName='createdFrom' [max]='today'
                            readonly
                            (focus)="createdFrom.open()" (click)="createdFrom.open()">
                        <button mat-icon-button matSuffix *ngIf="filterFormGroup.controls['createdFrom'].value"
                            (click)="filterFormGroup.controls['createdFrom'].setValue(''); makeFilter();">
                            <mat-icon>close</mat-icon>
                        </button>
                        <mat-datepicker-toggle matSuffix [for]="createdFrom"></mat-datepicker-toggle>
                        <mat-datepicker #createdFrom></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="col-lg-4 mb-3">
                    <mat-form-field class="no-validation">
                        <mat-label>{{"forms.Creation Date To" | translate}}</mat-label>
                        <input matInput [matDatepicker]="createdTo" formControlName='createdTo' [max]='today' readonly
                        (focus)="createdTo.open()" (click)="createdTo.open()">
                        <button mat-icon-button matSuffix *ngIf="filterFormGroup.controls['createdTo'].value"
                            (click)="filterFormGroup.controls['createdTo'].setValue(''); makeFilter();">
                            <mat-icon>close</mat-icon>
                        </button>
                        <mat-datepicker-toggle matSuffix [for]="createdTo"></mat-datepicker-toggle>
                        <mat-datepicker #createdTo></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="col-lg-2 mb-3">
                    <mat-form-field class="no-validation">
                        <mat-label>{{"content4.numberOfItemfrom" | translate}}</mat-label>
                        <input matInput formControlName="numberOfItemfrom" maxlength="8" appOnlynumber>
                    </mat-form-field>
                </div>
                <div class="col-lg-2 mb-3">
                    <mat-form-field class="no-validation">
                        <mat-label>{{"content4.numberOfItemto" | translate}}</mat-label>
                        <input matInput formControlName="numberOfItemto" maxlength="8" appOnlynumber>
                    </mat-form-field>
                </div>
            </div>

            <div class="btn-container">
                <button mat-stroked-button color="primary" (click)="makeFilter()">{{"general.Apply Filter" |
                    translate}}</button>
                <button mat-stroked-button (click)="clearFilter()">{{"general.Clear Filter" | translate}}</button>
            </div>
        </div>
    </div>

    <div *ngIf='dataLoading' class="dataLoading py-5">
        <mat-spinner class="m-auto" diameter="50"></mat-spinner>
    </div>

    <ng-container *ngIf='!dataLoading'>
        <div *ngIf="recordsData?.pageData && recordsData?.pageData?.length; else dataEmpty">
            <div class="cards-list">
                <div class="row">
                    <div *ngFor="let item of recordsData?.pageData" class="col-xl-3 col-lg-6 col-12">
                        <div class="card">
                            <div class="card-head">
                                <div class="card-title">
                                    <h4 *ngIf="lang == 'en'">{{item.title_EN}}</h4>
                                    <h4 *ngIf="lang == 'ar'">{{item.title_AR}}</h4>
                                </div>
                                <div class="card-actions">
                                    <button mat-icon-button (click)="openForm(item)" *ngIf="item.canEdit">
                                        <mat-icon>edit</mat-icon>
                                    </button>
                                    <button mat-icon-button (click)="deleteRecord(item.id)" *ngIf="item.canDelete">
                                        <mat-icon class="delete-icon">delete</mat-icon>
                                    </button>
                                </div>
                            </div>
                            <div class="card-content">
                                <ul class="content-list">
                                    <li class="d-flex align-items-center">
                                      <div>
                                        <b>{{item.numberOfUse}}</b> {{"forms.Items" | translate}}
                                      </div>
                                      <div class="ml-auto" *ngIf="item.numberOfUse">
                                        <a mat-icon-button
                                          [routerLink]="['/admin/menu-management/menu-items']"
                                          [queryParams]="{ category: item.id }">
                                          <mat-icon>remove_red_eye</mat-icon>
                                        </a>
                                      </div>
                                    </li>
                                    <li>{{"content.Added on" | translate}}: <b>{{item.created | date:'d MMM, y - h:mm a'}}</b></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="pagination-container" *ngIf="recordsData && (pageCount > 1 || recordsData['totalCount'] > pageSize)">
                <mat-paginator [length]="recordsData['totalCount']" [pageSize]="filterModel.pageSize"
                    [pageSizeOptions]="[4, 8, 12]" (page)="getAll($event, restaurantId)" [pageIndex]="pageIndex"></mat-paginator>
            </div>

        </div>
    </ng-container>

    <ng-template #dataEmpty>
        <empty-state [title]='"general.No Data Found" | translate'></empty-state>
    </ng-template>
</div>
